import { z } from "zod"
import { consentCodeParsed, ConsentKeyDenormalizer, ConsentValue } from "@/features/consents"

const CONSENT_EVENT_SOURCE = "ONBOARDING"

export const ConsentsSchema = z.object({
    [consentCodeParsed.relationalCommunication]: z.boolean(),
    [consentCodeParsed.commercialCommunication]: z.boolean(),
    [consentCodeParsed.personalCommunication]: z.boolean(),
})

export const ConsentsMutationNormalizer = ConsentsSchema.transform((data) => {
    return Object.keys(data).map((consentKey) => {
        return {
            consentTypeCode: ConsentKeyDenormalizer(consentKey),
            value: data[consentKey] ? ConsentValue.ACCEPTED : ConsentValue.REJECTED,
            source: CONSENT_EVENT_SOURCE,
        }
    }, [])
})
